import { useLocation } from "react-router-dom";

// Pages shared between the website and the Temple app link within whichever one they're shown in.
export const useBase = () => (useLocation().pathname.startsWith("/app") ? "/app" : "");

export const isStandalone = () =>
  window.matchMedia?.("(display-mode: standalone)").matches || window.navigator.standalone === true;
